import axios from 'axios'
import { useAuth0 } from 'app/Auth'
import { captureWarning } from 'lib/monitoring'

export const useCreateBetterIdRequest = () => {
  const { getAccessToken } = useAuth0()
  const tokenPromise = getAccessToken()
  const BETTER_ID_URL = process.env.REACT_APP_BETTER_ID_BASE_URL

  const createBetterIdRequest = async (
    url: string,
    params: any,
    method: 'GET' | 'POST' = 'POST'
  ) => {
    const token = await tokenPromise
    if (!token || !url) {
      throw new Error('No token or url found')
    }
    try {
      const config = {
        headers: {
          Authorization: `Bearer ${token}`,
        },
        ...(method === 'GET' ? { params } : {}),
      }

      const response =
        method === 'GET'
          ? await axios.get(`${BETTER_ID_URL}${url}`, config)
          : await axios.post(`${BETTER_ID_URL}${url}`, params, config)

      return response.data
    } catch (error) {
      captureWarning(error as Error)
      throw error
    }
  }
  return { createBetterIdRequest }
}
